var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "premium-settings-view flex-between-wrapper" },
    [
      _c("div", { staticClass: "premium-settings-view" }, [
        _c("h3", { staticClass: "view-title" }, [
          _vm._v("Gain more control and focus for your students."),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "view-description" }, [
          _vm._v(
            "Create a distraction-free experience for students by turning off ads. Enjoy more custom-settings like easily adjusting the minimum and maximum grade levels when using auto-assignments."
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-wrapper" },
          [
            _c("primary-button", { on: { click: _vm.handleClickPlan } }, [
              _vm._v("Choose your plan"),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "feature-image",
        attrs: { src: "/assets/app/class/settings-frame-bg.png" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }